const jQuery = window.jQuery;
const $ = jQuery;
const HG = window.HG || (window.HG = {});

const BaseUrl = `${window.location.protocol}//${window.location.hostname}`;

import 'babel-polyfill'; // ES5+6 Polyfill  //duplicate on mobile todo fix
import React from 'react';
import ReactDOM from 'react-dom';
import { HeaderV2, Theme, Container } from 'hui/dist/styled';
import CategoryAutocomplete from './components/category-site-search';
import PostcodeAutocomplete from '../../_common/scripts/components/postcode-autocomplete';
import { ThemeProvider } from 'styled-components';
import LoginBar from './components/login-bar';
import { AppContainer } from 'react-hot-loader';
import hui from 'hui';

const HoverMenu = hui.HoverMenu;
const LinkItem = hui.LinkItem;

const photoCategories = [
  { key: 'bathrooms', value: 'Bathrooms' },
  { key: 'exteriors', value: 'Exteriors' },
  { key: 'gardens', value: 'Gardens' },
  { key: 'kitchens', value: 'Kitchens' },
  { key: 'pools', value: 'Pools' },
  { key: 'decks', value: 'Timber Decks' }
];

const articleTopics = [
  { key: 'kitchens', value: 'Kitchens' },
  { key: 'bathrooms', value: 'Bathrooms' },
  { key: 'gardening', value: 'Gardening' },
  { key: 'building', value: 'Building' },
  { key: 'decking', value: 'Decking' }
];

// setup GA vars
const GA_CATEGORY = 'Header Menu';
const GA_LABEL = `${GA_CATEGORY} - Homepage`; // todo change this to dynamic pagetype
const GA_HOVER = true;

function search(category = '', postcode = '') {
  const params = {
    search_str: category.replace(/\s/g, '+'),
    search_zip: postcode.replace(/\s/g, '+'),
    m: 'search',
    a: 'search_results',
    dosql: 'do_search',
    search_code: 'p',
    search_what_header: 'what',
    search_where_header: 'where',
    loctype: 'zip'
  };
  const query = Object.keys(params)
    .reduce((accum, p) => [...accum, `${p}=${params[p]}`], [])
    .join('&');
  window.location.href = `${BaseUrl}/index.php?m=search&a=search_results&${query}`;
}

class Header {
  init() {
    $(() => {
      // init react elements
      // hero
      if (document.getElementById('new-header-container')) {
        ReactDOM.render(
          <AppContainer>
            <ThemeProvider theme={Theme}>
              <HeaderV2
                isHomepage
                enableAppBanner={false}
                appBannerSource={'Homepage'}
                appBannerReleaseDate={'20180130'}
              />
            </ThemeProvider>
          </AppContainer>,
          document.getElementById('new-header-container')
        );

        if (module.hot) {
          module.hot.accept('hui/dist/styled', () => {
            const NextApp = require('hui/dist/styled').HeaderV2; // eslint-disable-line global-require
            ReactDOM.render(
              <AppContainer>
                <ThemeProvider theme={Theme}>
                  <HeaderV2
                    isHomepage
                    enableAppBanner={false}
                    appBannerSource={'Homepage'}
                    appBannerReleaseDate={'20180130'}
                  />
                </ThemeProvider>
              </AppContainer>,
              document.getElementById('new-header-container')
            );
          });
        }

        return true;
      }
      ReactDOM.render(
        <CategoryAutocomplete classPrefix="category-site-search" value="" />,
        document.getElementById('headerCategoryAutocomplete')
      );
      ReactDOM.render(
        <PostcodeAutocomplete classPrefix="postcode-search" name="search_zip" />,
        document.getElementById('headerPostcodeAutocomplete')
      );

      ReactDOM.render(
        <CategoryAutocomplete classPrefix="mobile-category-search" value="" />,
        document.getElementById('mobileHeaderCategoryAutocomplete')
      );
      ReactDOM.render(
        <PostcodeAutocomplete classPrefix="mobile-postcode-search" name="search_zip" />,
        document.getElementById('mobileHeaderPostcodeAutocomplete')
      );

      ReactDOM.render(
        <LoginBar abTestTradieButton={window.abTestTradieButton} />,
        document.getElementById('headerLoginBar')
      );

      const catDiv = document.createElement('div');
      ReactDOM.render(
        <HoverMenu
          fancyArrow={false}
          id="headerNavCategories"
          className="hover-menu--categories hui-header__link"
          menuItem={
            <LinkItem
              GACategory={GA_CATEGORY}
              GAAction="Browse By Categories"
              GALabel={GA_LABEL}
              GAHover={GA_HOVER}
              href="/find"
              title="All trade categories"
            >
              <span className="hui-header__link--hidden-md">Trade</span> Categories
            </LinkItem>
          }
        >
          <ul className="hover-menu__list hover-menu__list--column">
            <li className="hover-menu__list--column__title">Popular Categories</li>
            {popularCategories.map(({ key, value }) => (
              <li key={key}>
                <LinkItem
                  GACategory={GA_CATEGORY}
                  GAAction={`Category ${value} - Sub Menu`}
                  GALabel={GA_LABEL}
                  href={`/find/${key}`}
                  title={value}
                >
                  {value}
                </LinkItem>
              </li>
            ))}
          </ul>
          <hr />
          <ul className="hover-menu__list hover-menu__list--column">
            {categories.map(({ key, value }) => (
              <li key={key}>
                <LinkItem
                  GACategory={GA_CATEGORY}
                  GAAction={`Category ${value} - Sub Menu`}
                  GALabel={GA_LABEL}
                  href={`/find/${key}`}
                  title={value}
                >
                  {value}
                </LinkItem>
              </li>
            ))}
          </ul>
          <div className="hover-menu__footer">
            <LinkItem
              GACategory={GA_CATEGORY}
              GAAction="Browse All Categories - Sub Menu"
              GALabel={GA_LABEL}
              title="View all category link"
              href="/find"
            >
              View all categories
            </LinkItem>
          </div>
        </HoverMenu>,
        catDiv
      );

      const photoDiv = document.createElement('div');
      ReactDOM.render(
        <HoverMenu
          fancyArrow={false}
          id="headerNavPhotos"
          className="hover-menu--photos hui-header__link hui-header__link--seperator"
          menuItem={
            <LinkItem
              GACategory={GA_CATEGORY}
              GAAction="Browse Photo"
              GALabel={GA_LABEL}
              GAHover={GA_HOVER}
              title="All Photos"
              href="/photos"
            >
              Photos
            </LinkItem>
          }
        >
          <ul className="hover-menu__list">
            {photoCategories.map(({ key, value }) => (
              <li key={key}>
                <LinkItem
                  GACategory={GA_CATEGORY}
                  GAAction={`Photos ${value} - Sub Menu`}
                  GALabel={GA_LABEL}
                  title={value}
                  href={`/photos/${key}`}
                >
                  {value}
                </LinkItem>
              </li>
            ))}
          </ul>
          <div className="hover-menu__footer">
            <LinkItem
              GACategory={GA_CATEGORY}
              GAAction="Browse All Photos Categories - Sub Menu"
              GALabel={GA_LABEL}
              title="View all photo categories link"
              href="/photos"
            >
              View all photo categories
            </LinkItem>
          </div>
        </HoverMenu>,
        photoDiv
      );

      const articleDiv = document.createElement('div');
      ReactDOM.render(
        <HoverMenu
          fancyArrow={false}
          id="headerNavArticles"
          className="hui-header__link"
          menuItem={
            <LinkItem
              GACategory={GA_CATEGORY}
              GAAction="Browse Articles"
              GALabel={GA_LABEL}
              GAHover={GA_HOVER}
              title="All Articles"
              href="/articles"
            >
              Articles
            </LinkItem>
          }
        >
          <ul className="hover-menu__list">
            {articleTopics.map(({ key, value }) => (
              <li key={key}>
                <LinkItem
                  GACategory={GA_CATEGORY}
                  GAAction={`Topic ${value} - Sub Menu`}
                  GALabel={GA_LABEL}
                  title={value}
                  href={`/c/${key}`}
                >
                  {value}
                </LinkItem>
              </li>
            ))}
          </ul>
          <div className="hover-menu__footer">
            <LinkItem
              GACategory={GA_CATEGORY}
              GAAction="Browse All Article Topics - Sub Menu"
              GALabel={GA_LABEL}
              title="View all article topics link"
              href="/articles"
            >
              View all article topics
            </LinkItem>
          </div>
        </HoverMenu>,
        articleDiv
      );

      const costGuidesDiv = document.createElement('div');
      ReactDOM.render(
        <HoverMenu
          fancyArrow={false}
          id="headerNavCostGuides"
          className="hui-header__link"
          menuItem={
            <LinkItem
              GACategory={GA_CATEGORY}
              GAAction="Cost Guides"
              GALabel={GA_LABEL}
              GAHover={GA_HOVER}
              title="All Cost Guides"
              href="/c/cost"
            >
              Cost Guides
            </LinkItem>
          }
        >
          <ul className="hover-menu__list">
            {costGuides.map(({ articleKey, topicName }) => (
              <li key={articleKey}>
                <LinkItem
                  GACategory={GA_CATEGORY}
                  GAAction={`Cost Guides ${topicName} - Sub Menu`}
                  GALabel={GA_LABEL}
                  title={topicName}
                  href={`/article/${articleKey}`}
                >
                  {topicName}
                </LinkItem>
              </li>
            ))}
          </ul>
          <div className="hover-menu__footer">
            <LinkItem
              GACategory={GA_CATEGORY}
              GAAction="Browse All Article Topics - Sub Menu"
              GALabel={GA_LABEL}
              title="View all cost guides link"
              href="/c/cost"
            >
              View all cost guides
            </LinkItem>
          </div>
        </HoverMenu>,
        costGuidesDiv
      );

      const headerNav = document.getElementById('headerNav');
      headerNav.replaceChild(catDiv.querySelector('#headerNavCategories'), document.getElementById('headerNavCategories'));
      headerNav.replaceChild(photoDiv.querySelector('#headerNavPhotos'), document.getElementById('headerNavPhotos'));
      headerNav.replaceChild(articleDiv.querySelector('#headerNavArticles'), document.getElementById('headerNavArticles'));
      headerNav.replaceChild(
        costGuidesDiv.querySelector('#headerNavCostGuides'),
        document.getElementById('headerNavCostGuides')
      );

      // mobile menu toggles
      $('#mobileHeaderSearchBtn').on('click', function () {
        $('#mobileHeaderNavBtn').removeClass('hui-header__mobile-burger--selected');
        $('#mobileHeaderNav').removeClass('hui-header__mobile-content--open');
        if ($(this).hasClass('hui-header__mobile-search--selected')) {
          $(this).removeClass('hui-header__mobile-search--selected');
          $('#mobileHeaderSearch').removeClass('hui-header__mobile-content--open');
        } else {
          $(this).addClass('hui-header__mobile-search--selected');
          $('#mobileHeaderSearch').addClass('hui-header__mobile-content--open');
        }
      });

      $('#mobileHeaderNavBtn').on('click', function () {
        $('#mobileHeaderSearchBtn').removeClass('hui-header__mobile-search--selected');
        $('#mobileHeaderSearch').removeClass('hui-header__mobile-content--open');
        if ($(this).hasClass('hui-header__mobile-burger--selected')) {
          $(this).removeClass('hui-header__mobile-burger--selected');
          $('#mobileHeaderNav').removeClass('hui-header__mobile-content--open');
        } else {
          $(this).addClass('hui-header__mobile-burger--selected');
          $('#mobileHeaderNav').addClass('hui-header__mobile-content--open');
        }
      });

      $('#headerSearchbar').on('submit', (e) => {
        e.preventDefault();
        const categorySiteText = $('#headerSearchbar [name=search_str]').val();
        const postcodeText = $('#headerSearchbar [name=search_zip]').val();
        if (categorySiteText) {
          search(categorySiteText, postcodeText);
        } else {
          alert('Please enter a Keyword or select a Category to search'); // eslint-disable-line no-alert
        }
      });

      $('#headerMobileSearchbar').on('submit', (e) => {
        e.preventDefault();
        const categorySiteText = $('#headerMobileSearchbar [name=search_str]').val();
        const postcodeText = $('#headerMobileSearchbar [name=search_zip]').val();
        if (categorySiteText) {
          search(categorySiteText, postcodeText);
        } else {
          alert('Please enter a Keyword or select a Category to search'); // eslint-disable-line no-alert
        }
      });

      // submit mobile fields
    });
  }
}

export default Header;

HG.Header = new Header();
HG.Header.init();



// WEBPACK FOOTER //
// ./header/scripts/main.js